<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     产品追溯列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="mm-product header-padding">
    
    <f-page-header />

    <div class="filter-container">

      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="radios" type="arrow" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
      </div>

    </div>


    <el-card v-loading="loading" class="table-card" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        style="width: 100%"
        size="medium"
        class="padding-small"
        @selection-change="handleSelectionChange">

        <el-table-column
          type="selection"
          width="60">
        </el-table-column>

        <el-table-column label="产品图" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.money_total | currency }}</span>
          </template>
        </el-table-column>

        <el-table-column label="制号/名称/型号" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="text-muted">{{ scope.row.material_no}}</div>
            <div class="">{{ scope.row.material_title}}</div>
          </template>
        </el-table-column>

        <el-table-column label="数量" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.status }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="240" show-overflow-tooltip>
          <template slot="header">
            <div class="flex justify-content-space-between">
              <span>创建时间</span>
              <span>发货时间</span>
              <span>验收时间</span>
            </div>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
          </template>
        </el-table-column>

        <el-table-column label="已用时" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品编号" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>

        <el-table-column label="关联项目" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>


        <el-table-column label="操作" align="right" min-width="60">
          <template slot-scope="scope">
            <el-button type="text" @click="viewBill(scope.row)">详情</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png">
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer checkbox :list="list" :selection="multiSelection" @toggle="toggleAll" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData">
      <template slot="left">
        <el-button plain :disabled="total === 0" size="mini" @click="exportM">导出</el-button>
      </template>
    </f-table-footer>

    <mm-material-import v-if="importShow" :show.sync="importShow" @submit="fetchData(1)" />
  </div>
</template>

<script>
import { getMaterialListApi } from '@/api/mm/materialApi'

export default {
  name: "MmMaterial",

  components: {
    MmMaterialImport: () => import('@/views/mm/components/MmMaterialImport'),
  },

  data() {
    return {
      dialogShow: false,
      importShow: false,
      query: {
        keyword: '',
        status: 0,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      total: 0,
      multiSelection: [],
      radios: [
        { value: 1, title: '全部', separate: true },
        { value: 2, title: '待制造' },
        { value: 3, title: '在制中' },
        { value: 4, title: '已发货' },
        { value: 5, title: '已验收' }
      ],
      list: [],
      loading: false
    }
  },

  computed: {
  },

  created() {
    this.fetchData()
  },


  methods: {
    fetchData (page, loading = true) {
      if (page) this.query.pindex = page
      if (loading) this.loading = true
      getMaterialListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },

    handleSelectionChange (val) {
      this.multiSelection = val
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    deleteM() {},

    issue() {},

    exportM() {}
  }

}
</script>

<style lang="scss" scoped>
.mm-material {
  position: relative;
}
</style>
